import {
  ComponentService,
  DataTransmissionService,
  DbCommonColumnName,
  MessageService,
  ResponseDataModel,
  ShowDefaultDialogService,
  ViewType,
} from '@ktvs8/gocoo-engine-front-end';
import { MProgramOrderSelectedResult } from '../develop/Dialog/m-program-order-dialog-list';

/**
 * MProgramOrderに関するユーティリティ
 *
 */
export namespace MProgramOrderUtility {
  /**
   * 番組マスタのレコードを取得する
   * @param mProgramOrderTicketKey
   * @returns
   */
  export async function fetchMProgramOrderSelectedResult(
    mProgramOrderTicketKey: string
  ): Promise<MProgramOrderSelectedResult> {
    const condition = {
      [DbCommonColumnName.TICKET_TYPE]: 'MProgramOrder',
      [DbCommonColumnName.TICKET_KEY]: mProgramOrderTicketKey,
    };

    let componentService = new ComponentService(new ShowDefaultDialogService(), new MessageService());
    let dtService = new DataTransmissionService(componentService);

    return new Promise<MProgramOrderSelectedResult>((resolve, reject) => {
      const callBack = (result: ResponseDataModel) => {
        if (!result.isCompleted) {
          reject(result);
        }

        const model = <MProgramOrderSelectedResult>{
          ticketKey: result.data['TicketKey'],
          content: result.data['Content'],
        };

        resolve(model);
      };

      dtService.fetchRecord(ViewType.Edit, 'MProgramOrder', condition, callBack, false, null);
    });
  }
}
